export const EXPERIMENTAL_CHAT_FLAG_KEY = 'sweep.experimental.chat';

declare global {
    interface Window {
        __SWEEP_EXPERIMENTAL_CHAT?: boolean;
    }
}

export function isExperimentalChatEnabled(): boolean {
    if (typeof window === 'undefined') return false;
    if (typeof window.__SWEEP_EXPERIMENTAL_CHAT === 'boolean') {
        return window.__SWEEP_EXPERIMENTAL_CHAT;
    }
    return localStorage.getItem(EXPERIMENTAL_CHAT_FLAG_KEY) === '1';
}

export function setExperimentalChatEnabled(enabled: boolean): void {
    if (typeof window === 'undefined') return;
    window.__SWEEP_EXPERIMENTAL_CHAT = enabled;
    if (enabled) {
        localStorage.setItem(EXPERIMENTAL_CHAT_FLAG_KEY, '1');
    } else {
        localStorage.removeItem(EXPERIMENTAL_CHAT_FLAG_KEY);
    }
}


